<template>
    <b-container fluid>
        <b-row class="">
            <b-col cols="12" md="12" class="w-100">
                <h3>{{$t('users.title')}}</h3>
            </b-col>
        </b-row>

        <hr/>
        <b-container fluid class="dashboardTile p-4 shadow-lg">
        <b-row v-if="users">
            <b-col cols="12">
                <events-table position
                              search-key="username"
                              :items="users"
                              :fields="usersFields"
                              :actions="actions"
                              @action="action">
                </events-table>
            </b-col>
        </b-row>
        </b-container>

        <b-modal centered
                 id="deleteUserModal"
                 ref="deleteUserModal"
                 @ok="deleteUser"
                 ok-variant="danger"><template v-slot:modal-title>
                    {{$t('prepaid.group.card.modal.delTitle')}}
                </template>
            <p class="my-4">{{$t('toast.users.delete.msg')}}</p>
        </b-modal>

        <b-modal centered
                 id="editUserModal"
                 ref="editUserModal"
                 title="Edit user"
                 @ok="updateUser()"
                 ok-variant="success">
                 <template v-slot:modal-title>
                    {{$t('users.modal.title')}}
                </template>
            <b-row class="justify-content-center align-items-center p-4 m-4">
            <b-col cols="12">
                <b-form v-on:submit.prevent="register" class="auth-form"  data-vv-scope="editUser">
                    <b-form-group label="Email"
                                  label-for="email">
                        <b-form-input :state="validateState('editUser.email')"
                                      :class="{'is-invalid': veeErrors.has('editUser.email')}"
                                      v-model="editUser.email" v-validate="'required|email'" id="email" type="email" size="md" name="email" required></b-form-input>
                        <span class="vvError">{{ veeErrors.first('editUser.email') }}</span>
                    </b-form-group>

                    <b-form-group label-for="username">{{$t('users.modal.username')}}
                        <b-form-input :state="validateState('editUser.username')"
                                      :class="{'is-invalid': veeErrors.has('editUser.username')}"
                                      v-model="editUser.username" v-validate="'required|min:4'" id="username" type="text" size="md" name="username" required></b-form-input>
                        <span class="vvError">{{ veeErrors.first('editUser.username') }}</span>
                    </b-form-group>

                    <b-form-group label-for="role">{{$t('users.modal.role')}}
                        <b-form-select v-model="editUser.role_id" name="role" v-validate="'required'">
                            <option v-for="role in roles" :value="role.id">{{role.name}}</option>
                        </b-form-select>
                        <span class="vvError">{{ veeErrors.first('editUser.role') }}</span>
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
        </b-modal>
    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'users',
        data() {
            return {
                users: null,
                editUser: {},
                deletionUser: {},
                roles: [],
                usersFields: [
                    {
                        key: 'username',
                        labelPath:'table.users.lable',
                        sortable: true
                    },
                    {
                        key: 'email',
                        labelPath: 'table.users.email',
                        sortable: true,
                        thClass: 'd-none d-lg-table-cell',
                        tdClass: 'd-none d-lg-table-cell' 
                    },
                     {
                        key: 'role_name',
                        labelPath: 'table.users.role',
                        sortable: true,
                        thClass: 'd-none d-lg-table-cell',
                        tdClass: 'd-none d-lg-table-cell' 
                    }
                    
                ],
                actions: {
                    update: {
                        name: 'hover.edit',
                        icon: 'fas fa-edit'
                    },
                    delete: {
                        name: 'hover.delete',
                        icon: 'fas fa-trash'
                    }
                },
            }
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            updateUser(){
                this.$axios.post('editUser',this.editUser).then(response => {
                    if (response.data.success){
                        this.editUser = response.data.data;
                        this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                    }else{
                        this.$toasted.global.err({
                                    message : this.$t(response.data.data.msg)
                                });
                    }
                })
            },
            deleteUser(){
                this.$axios.post('deleteUser',this.deletionUser).then(response => {
                    if (response.data.success){
                        this.deletionUser = response.data.data;
                        this.getUsers();
                        this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                             });
                 }else{
                     this.$toasted.global.err({
                                    message : this.$t(response.data.data.msg)
                             });
                     }
                 })
            },
            getUsers(){
            this.$axios.get('users').then(response => {
                if (response.status === 200) {
                    this.users = response.data.data;
                }
            })
            },
            getRoles(){
                this.$axios.get('roles').then(response => {
                    if (response.status === 200) {
                        this.roles = response.data.data;
                    }
                })
            },
            editModal(item){
                this.editUser = item;
                this.$refs.editUserModal.show();
            },
            deleteModal(item){
                this.deletionUser = item;
                this.$refs.deleteUserModal.show();
            },
            action: function (action, item) {
                switch (action) {
                    case 'update':
                        this.editModal(item);
                        break;
                    case 'delete':
                        this.deleteModal(item);
                        break;
                }
            },
        },


        created() {
            this.getUsers();

            this.getRoles();
        },
    };
</script>
